module.exports = __webpack_public_path__ + "static/media/judy_kang.a0d3e439.jpg";